import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getUserAccessBreakdown = api(async function getUserAccessBreakdown({ clientId, userId }) {
    return query(
        gql`
            query getUserAccessBreakdown($clientId: String, $userId: String) {
                getUserAccessBreakdown(clientId: $clientId, userId: $userId)
            }
        `,
        { clientId, userId },
        { returns: "getUserAccessBreakdown" }
    )
})
